import { SHELL_VERSION } from "@bestowinc/tinkertoy-shell-deps";

/** Resolved shell version for failure telemetry attributes. */
export function getErrorTelemetryShellVersion(): string {
  return SHELL_VERSION;
}
